export default "__VITE_ASSET__mV$xE$ws__"